module.exports = __webpack_public_path__ + "static/media/-_Payroll.782332a2.png";